import { lazy } from 'react';
import { Navigate } from 'react-router-dom';
import { RouteObject } from 'react-router';
import RoutesLoader from 'src/components/RoutesLoader';
import ParentLayout from 'src/layouts/ParentLayout';

const ParentDashboard = RoutesLoader(
  lazy(() => import('src/pages/Parent/Dashboard/Index'))
);
const MyAccount = RoutesLoader(
  lazy(() => import('src/pages/Parent/MyAccount/Index'))
);
const PaymentDetails = RoutesLoader(
  lazy(() => import('src/pages/Parent/Dashboard/PaymentDetails/Index'))
);

const parentRoute: RouteObject[] = [
  {
    path: '',
    element: <Navigate to="parent" replace />
  },
  {
    path: 'parent',
    element: <ParentLayout />,
    children: [
      {
        path: '',
        element: <Navigate to="dashboard" replace />
      },
      {
        path: 'dashboard',
        element: <ParentDashboard />
      },
      {
        path: 'payments',
        element: <PaymentDetails />
      },
      {
        path: 'my-account',
        element: <MyAccount />
      }
    ]
  }
];

export default parentRoute;
